import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/service/app.service';
import { UserService } from 'src/app/service/user-service.service';
import { endpoints } from 'src/endpoint/endpoints';
import { PazientiService } from '../pazienti/service/pazienti.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  layoutEnabled = 'layout6';

  datePipe = new DatePipe('en-US');

  totalPatient = 0;

  patients = [];

  numeroPazientiMonitorati = 0;

  clinicalImpressionList = [];

  alertList = [];

  practitioners;

  organizationChildrenSelected;

  chartPazientiPresiInCarico: ApexCharts;
  @ViewChild('chartPazientiPresiInCarico') chartPazientiPresiInCaricoRef: ElementRef;
  totPazientiPresiInCarico = 0;
  totDiabeticiIpertesi = 0;
  totDiabeticiNonIpertesi = 0;
  totDialitici = 0;
  totPredialitici = 0;
  totControllo = 0;

  chartPazientiMonitorati: ApexCharts;
  @ViewChild('chartPazientiMonitorati') chartPazientiMonitoratiRef: ElementRef;
  totPazientiMonitorati = 0;
  totDiabeticiIpertesiMonitorati = 0;
  totDiabeticiNonIpertesiMonitorati = 0;
  totDialiticiMonitorati = 0;
  totPredialiticiMonitorati = 0;
  totControlloMonitorati = 0;

  totFollowup = 0;
  totFollowupPrevisti = 0;
  totFollowupMancanti = 0;

  totUltimeVisite = 0;
  totUltimeVisitePreviste = 0;
  totUltimeVisiteMancanti = 0;

  totDropout = 0;
  totDeceduti = 0;
  totNonReperibili = 0;
  totSiRifiutaDiContinuare = 0;
  totNonSpecificato = 0;

  totEventi = 0;
  totEventiScompenso = 0;
  totEventiAltro = 0;
  totEventiEquivalenti = 0;

  ultimeVisiteInserite = [];
  columns_last_followups = [
    { field: 'patient_identifier', header: 'Paziente' },
    { field: 'description', header: 'Tipologia' },
    { field: 'effectiveDateTime', header: 'Data' },
  ];

  ultimiPazientiInseriti = [];
  columns_last_patients = [
    { field: 'patient_identifier', header: 'Identificativo' },
    { field: 'label', header: 'Etichetta' },
    { field: 'age', header: 'Età' },
    { field: 'gender', header: 'Genere' },
  ];

  lastEvents = []

  constructor(private http: HttpClient, private userService: UserService, private router: Router, private pazientiService: PazientiService,
    private appSrv: AppService, private cdr: ChangeDetectorRef, private toastr: ToastrService) { }

  ngOnInit() {
    // Rimuovo il paziente selezionato
    this.pazientiService.resetPatient();

    this.organizationChildrenSelected = { display: this.userService.getCurrentOrganizationObj().organization, id: "" + this.userService.getCurrentOrganizationObj().id, ref: (this.userService.getCurrentOrganizationObj() as any).referenceId };
    this.userService.getPractitionersAsPromise(this.http).then((resp: any) => {
      this.practitioners = resp;
      switch (this.layoutEnabled) {
        case "layout1":
          this.countPatient();
          this.countPazientiDisattivati();
          this.getClinicalImpressionList();
          this.getAlertList();
          break;
        case "layout2":
        case "layout3":
        case "layout3":
        default:
          // Dashboard analytics
          this.retrieveData();
          break;
      }
    });

  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  countPatient() {
    this.http.get(endpoints.getCountPatient + this.practitioners).subscribe((resp: any) => {
      this.totalPatient = resp.total ?? 1016;
      if (resp.entry) {
        this.patients = resp.entry.map(elem => ({
          id: elem.resource.id,
          identifier: this.pazientiService.getPatientIdFromPatientObject(elem.resource),
          // tslint:disable-next-line: max-line-length
          nome: this.pazientiService.getPatientName(elem.resource),
          // tslint:disable-next-line: max-line-length
          cognome: this.pazientiService.getPatientSurname(elem.resource),
          birthDate: elem.resource.birthDate ? this.datePipe.transform(new Date(Date.parse(elem.resource.birthDate)), 'dd/MM/yyyy') : '',
          gender: this.getGender(elem.resource.gender)
        })
        );
      } else {
        this.patients = [];
      }
    });
  }

  countPazientiDisattivati() {
    const query = endpoints.getDisabledUsersByOrganization + '?pageIndex=0&pageSize=1&&organizations=' + this.organizationChildrenSelected.ref.split('/')[1];
    this.http.get(query).subscribe((resp: any) => {
      this.numeroPazientiMonitorati = resp.object.totalElements;
    });
  }

  getGender(gender) {
    if (gender === 'male') {
      return 'Maschio';
    }
    if (gender === 'female') {
      return 'Femmina';
    }
    if (gender === 'other') {
      return 'Altro';
    }
    if (gender === 'unknown') {
      return 'Sconosciuto';
    }
  }

  goToDettagli(elem) {
    this.pazientiService.setPatientId(elem);
    this.appSrv.setPatientListFrom('stiledivita');
    this.router.navigate(['/main/pazienti/profilosanitario', elem, 'stiledivita']);
  }

  goToVisit(id, patId) {
    this.pazientiService.setPatientId(patId);
    this.appSrv.setPatientListFrom('visite');
    this.router.navigate(['/main/pazienti/visite', patId, 'osservazioni', id, 'stiledivita']);
  }

  gotoAnagrafica(elem) {
    this.pazientiService.setPatientId(elem);
    this.appSrv.setPatientListFrom('stiledivita');
    this.router.navigate(['/main/pazienti/schedapaziente', elem.patient_id]);
  }

  getClinicalImpressionList() {
    this.http.get(endpoints.getClinicalImpressionListApi + this.practitioners).toPromise()
      .then((resp: any) => {
        if (resp && resp.total > 0) {
          this.clinicalImpressionList = resp.entry.map(elem => ({
            id: elem.resource.id,
            date: elem.resource.date ? this.datePipe.transform(new Date(Date.parse(elem.resource.date)), 'dd/MM/yyyy') : '',
            // tslint:disable-next-line: max-line-length
            patientId: elem.resource.subject.reference.split('/')[1],
            descrizione: elem.resource.description,
            type: elem.resource.description === 'Prima visita' ? 'badge-success' : 'badge-warning',
            patient: this.getPatient(elem.resource.subject.reference.split('/')[1])
          }))
        }
      }).catch(err => {
        console.error(err);
      });
  }


  getPatient(patientId) {
    return this.http.get(endpoints.getPatientByPatientId + patientId).toPromise().then((resp: any) => {
      if (resp && resp.message.identifier) {
        const identifier = resp.message.identifier.find(identifierCode => identifierCode.use == "usual");
        return identifier ? identifier.value : "";
      } else {
        return "";
      }
    });
  }


  getAlertList() {
    const query = endpoints.getAlerts + '/vital-signs/registed';
    this.http.get(query).subscribe((resp: any) => {
      if (resp.entry) {
        this.alertList = resp.entry.map(elem => ({
          id: elem.resource.id,
          patient: this.getPatient(elem.resource.subject.reference.split('/')[1]),
          // tslint:disable-next-line: max-line-length
          misura: this.getTypeMeasure(elem.resource.code.coding[0].code),
          value: elem.resource.valueQuantity.value,
          // tslint:disable-next-line: max-line-length
          date: elem.resource.effectiveDateTime ? this.datePipe.transform(new Date(Date.parse(elem.resource.effectiveDateTime)), 'dd/MM/yyyy HH:mm') : '',
          message: this.getMessage(elem.resource.valueQuantity.value, elem.resource.referenceRange[0]),
          level: this.getLevel(elem.resource.valueQuantity.value, elem.resource.referenceRange[0]),
          // tslint:disable-next-line: max-line-length
          detail: 'Verificato il ' + this.datePipe.transform(new Date(Date.parse(elem.resource.meta.lastUpdated)), 'dd/MM/yyyy HH:mm'),
          actions: elem.resource.comment
        })
        );
      } else {
        this.alertList = [];
      }
    });
  }

  getTypeMeasure(code) {
    switch (code) {
      case '8867-4': return 'Frequenza cardiaca';
      case '59408-5': return 'Ossigenazione';
      case '8462-4': return 'Diastolica';
      case '8480-6': return 'Sistolica';
      case 'pain': return 'Dolore';
      default: return '';
    }
  }

  getLevel(value, range) {
    if (value > range.high.value) {
      if ((value - range.high.value) <= range.high.value / 100 * 10) {
        return 1;
      } else {
        return 2;
      }
    } else if (value < range.low.value) {
      if ((value - range.low.value) <= range.low.value / 100 * 10) {
        return 1;
      } else {
        return 2;
      }
    }
  }

  getMessage(value, range) {
    if (value > range.high.value) {
      return 'Valore sopra la soglia impostata di ' + range.high.value;
    } else if (value < range.low.value) {
      return 'Valore sotto la soglia impostata di ' + range.low.value;
    }
  }

  goToListPatient() {
    this.pazientiService.resetPatient();
    this.appSrv.setPatientListFrom('lista_pazienti');
    this.router.navigate(['/main/pazienti/listapazienti']);
  }

  goToVisits() {
    this.appSrv.setPatientListFrom('visite');
    this.router.navigate(['/main/pazienti/listapazienti']);
  }

  goToAlerts() {
    this.appSrv.setPatientListFrom('alert');
    this.router.navigate(['/main/pazienti/listapazienti']);
  }

  checkPermessoLetturaNotifiche(): boolean {
    return this.userService.checkOnlyPermission('Notifiche', 'read');
  }

  checkPermessoLetturaVisite(): boolean {
    return this.userService.checkOnlyPermission('Visite', 'read');
  }

  loadDataFromResponse(resp: any) {
    this.totPazientiPresiInCarico = resp.totale;
    this.totDiabeticiIpertesi = resp.diabeticiIpertesi;
    this.totDiabeticiNonIpertesi = resp.diabeticiNonIpertesi;
    this.totDialitici = resp.dialitici;
    this.totPredialitici = resp.predialitici;
    this.totControllo = resp.controllo;

    const chartOptions = {
      series: [this.totDiabeticiIpertesi, this.totDiabeticiNonIpertesi, this.totDialitici, this.totPredialitici, this.totControllo],
      labels: ['Diabetici ipertesi', 'Diabetici non ipertesi', 'Dialitici', 'Predialitici', 'Controllo'],
      chart: {
        type: 'donut'
      },
      plotOptions: {
        pie: {
          customScale: 0.8
        }
      },
      legend: {
        fontSize: "13px"
      },
    };

    if (this.chartPazientiPresiInCaricoRef != undefined) {
      this.chartPazientiPresiInCarico = new ApexCharts(this.chartPazientiPresiInCaricoRef.nativeElement, chartOptions);
      this.chartPazientiPresiInCarico.render();
    }


    this.totPazientiMonitorati = resp.totaleMonitorati;
    this.totDiabeticiIpertesiMonitorati = resp.monitoratiDiabeticiIpertesi;
    this.totDiabeticiNonIpertesiMonitorati = resp.monitoratiDiabeticiNonIpertesi;
    this.totDialiticiMonitorati = resp.monitoratiDialitici;
    this.totPredialiticiMonitorati = resp.monitoratiPredialitici;
    this.totControlloMonitorati = resp.monitoratiControllo;

    const chartOptionsMonitorati = {
      series: [this.totDiabeticiIpertesiMonitorati, this.totDiabeticiNonIpertesiMonitorati, this.totDialiticiMonitorati, this.totPredialiticiMonitorati, this.totControlloMonitorati],
      labels: ['Diabetici ipertesi', 'Diabetici non ipertesi', 'Dialitici', 'Predialitici', 'Controllo'],
      chart: {
        type: 'donut'
      },
      plotOptions: {
        pie: {
          customScale: 0.8
        }
      },
      legend: {
        fontSize: "13px"
      },
    };

    if (this.chartPazientiMonitoratiRef != undefined) {
      this.chartPazientiMonitorati = new ApexCharts(this.chartPazientiMonitoratiRef.nativeElement, chartOptionsMonitorati);
      this.chartPazientiMonitorati.render();
    }

    this.totDropout = resp.totDropout;
    this.totDeceduti = resp.dropDeceduti;
    this.totNonReperibili = resp.dropNonReperibili;
    this.totSiRifiutaDiContinuare = resp.dropSiRifiutaDiContinuare;
    this.totNonSpecificato = resp.dropNonSpecificato;

    this.totFollowup = resp.totFollowupFatti;
    this.totFollowupPrevisti = resp.totFollowupPrevisti;
    this.totFollowupMancanti = resp.totFollowupMancanti;
    this.totUltimeVisite = resp.totUltimeVisiteFatte;
    this.totUltimeVisitePreviste = resp.totUltimeVisitePreviste;
    this.totUltimeVisiteMancanti = resp.totUltimeVisiteMancanti;

    this.totEventi = resp.totScompensi + resp.totAltriTipi;
    this.totEventiScompenso = resp.totScompensi;
    this.totEventiAltro = resp.totAltriTipi;
    this.totEventiEquivalenti = resp.totEventiEquivalenti;

  }

  loadPatientsStats() {
    this.http.get(endpoints.allStats).toPromise().then((resp: any) => {
      this.loadDataFromResponse(resp);
    }).catch(error => {
      console.error("Errore nel recupero dei dati", error);
      this.toastr.error("Errore nel recupero delle informazioni.");
    });
  }


  retrieveData() {
    // return;
    this.loadPatientsStats();
    this.loadUltimeNVisite();
    this.loadUltimiNPazienti();
    this.loadUltimiNEventi();
  }

  test() {
    this.retrieveData();
  }

  loadUltimeNVisite() {
    this.ultimeVisiteInserite = [];

    this.http.get(endpoints.getLastNClinicalImpression + 5).toPromise().then((resp: any) => {
      resp.forEach(ci => {

        this.ultimeVisiteInserite.push(
          {
            "id": ci["id"],
            "description": ci["description"],
            "summary": ci["summary"],
            "effectiveDateTime": ci["effectiveDateTime"],
            "patient_identifier": this.pazientiService.getPatientIdentifier(ci["subject"]["resource"]),
            "patient_id": ci["subject"]["resource"]["id"],
            "badgeType": ci["description"] == 'Prima visita' ? 'badge-info' : (ci["description"] == 'FollowUp') ? 'badge-warning' : 'badge-success'
          }
        );

        this.clinicalImpressionList.push({
          "paziente": this.pazientiService.getPatientIdentifier(ci["subject"]["resource"]),
          "patientId": ci["subject"]["resource"]["id"],
          "id": ci["id"],
          "type": ci["description"] == 'Prima visita' ? 'badge-info' : (ci["description"] == 'FollowUp') ? 'badge-warning' : 'badge-success',
          "descrizione": ci["description"],
          "date": ci["effectiveDateTime"]
        })
      });

    }).catch(error => {
      console.error(error);
      this.toastr.error("Errore nel recupero delle ultime visite inserite.");
    })
  }

  loadUltimiNPazienti() {
    this.ultimiPazientiInseriti = [];

    this.http.get(endpoints.getLastNPatients + 5).toPromise().then(resp => {

      (resp as any).forEach(patient => {
        this.ultimiPazientiInseriti.push({
          "patient_identifier": this.pazientiService.getPatientIdentifier(patient),
          "label": this.pazientiService.getAllLabels(patient).join("\n"),
          "age": this.pazientiService.getAgeFromFhirPatient(patient),
          "gender": this.getGender(patient.gender),
          "patient_id": patient["id"],
          "data_consenso_informato": this.pazientiService.getAcceptanceFromFhirPatient(patient)
        })
      });

    }).catch(error => {
      this.toastr.error("Errore nel recupero degli ultimi pazienti inseriti.");
      console.error(error);
    });
  }

  loadUltimiNEventi() {
    this.lastEvents = [];

    this.http.get(endpoints.getLastNEvents + 5).toPromise().then(resp => {

      (resp as any).forEach(ev => {
        this.lastEvents.push({
          "patient_identifier": this.pazientiService.getPatientIdentifier(ev["subject"]["resource"]),
          "patient_id": ev["subject"]["resource"]["id"],
          "effectiveDate": ev["comment"],
          "displayEvent": ev["valueCodeableConcept"]["coding"][0]["display"]
        })
      });

    }).catch(error => {
      this.toastr.error("Errore nel recupero degli ultimi eventi inseriti.");
      console.error(error);
    })
  }

  gotoTimelineVisite(elem) {
    this.pazientiService.setPatientId(elem.patient_id);
    this.appSrv.setPatientListFrom('stiledivita');
    this.router.navigate(['/main/pazienti/visite', elem.patient_id]);
  }

}
